
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1i2wg_1bfqe_17",
  "dismiss-button": "awsui_dismiss-button_1i2wg_1bfqe_49",
  "dismiss-button-inline": "awsui_dismiss-button-inline_1i2wg_1bfqe_90",
  "icon": "awsui_icon_1i2wg_1bfqe_101",
  "icon-inline": "awsui_icon-inline_1i2wg_1bfqe_107",
  "token-normal": "awsui_token-normal_1i2wg_1bfqe_112",
  "token-inline": "awsui_token-inline_1i2wg_1bfqe_119",
  "token-option-inline-dismissible": "awsui_token-option-inline-dismissible_1i2wg_1bfqe_145",
  "token-box": "awsui_token-box_1i2wg_1bfqe_149",
  "token-box-without-dismiss": "awsui_token-box-without-dismiss_1i2wg_1bfqe_168",
  "token-box-inline": "awsui_token-box-inline_1i2wg_1bfqe_172",
  "disable-padding": "awsui_disable-padding_1i2wg_1bfqe_192",
  "token-box-readonly": "awsui_token-box-readonly_1i2wg_1bfqe_199",
  "token-box-disabled": "awsui_token-box-disabled_1i2wg_1bfqe_200"
};
  